import './BgAnim.css';
const BgAnim = (props)=>{
    return (
    <div className="bg-anim">
        <ul className="d-logos">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    </div>
    );
}

export default BgAnim;










